var React = require('react');

function Kebob (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#CCD1D2","fillRule":"evenodd","transform":"rotate(90 1.75 1.75)"},[React.createElement("path",{"d":"M1.5 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM6 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z","key":0}),React.createElement("circle",{"cx":"10.5","cy":"1.5","r":"1.5","key":1})]));
}

Kebob.defaultProps = {"width":"4","height":"12","viewBox":"0 0 4 12"};

module.exports = Kebob;

Kebob.default = Kebob;
